import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ClientPolicyModel from "../../models/client-policy";

export default class ClientPolicyRepository extends BaseRepository {
  static modelClass = ClientPolicyModel;
  modelName = "client-policy";
}
